import { cn } from '@/lib/utils';

interface loaderProps {
  isOpen?: boolean;
}

const Loader = ({ isOpen = false }: loaderProps) => {
  return (
    <div
      className={cn(
        'fixed z-9999 inset-0 flex items-center justify-center transition-all duration-300',
        isOpen ? 'visible opacity-100' : 'invisible opacity-0'
      )}
    >
      <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}></div>
      <span
        data-testid="loader-spinner"
        className="relative w-12 h-12 rounded-full animate-loader-spin before:content-[''] before:box-border before:absolute before:inset-0 before:rounded-full before:border-[5px] before:border-white before:animate-loader-clip"
      ></span>
    </div>
  );
};

export default Loader;
